<template>
  <div class="skeleton-shape" :style="{ width, height, borderRadius }" />
</template>

<script>
  export default {
    name: 'SkeletonShape',
    props: {
      width: {
        type: String,
        required: true,
      },
      height: {
        type: String,
        required: true,
      },
      borderRadius: String,
    }
  }
</script>